import { AppState } from '../state';

export const loginLanguageSelector = (
    state: AppState
): typeof state.loginPage.loginSelectedLanguage =>
    state.loginPage.loginSelectedLanguage;
